import { useId, useLayoutEffect, useState } from 'react'

export const globalStack: Record<string, [string, (time: number) => void][]> = {}

export const useStack = (namespace: string, isEnabled?: boolean) => {
  const id = useId()
  const [, forceRender] = useState(Date.now())

  const stack = (globalStack[namespace] ??= [])
  const isActive = stack[0]?.[0] === id

  useLayoutEffect(() => {
    const addToStack = () => {
      const index = stack.findIndex(([itemId]) => itemId === id)
      if (index !== -1) return
      stack.unshift([id, forceRender])
      stack[0]?.[1](Date.now())
      stack[1]?.[1](Date.now())
    }

    const removeFromStack = () => {
      const index = stack.findIndex(([itemId]) => itemId === id)
      if (index === -1) return
      stack.splice(index, 1)
      if (index !== 0) return
      stack[0]?.[1](Date.now())
    }

    if (isEnabled === false) removeFromStack()
    else addToStack()

    return () => {
      removeFromStack()
    }
  }, [isEnabled])

  return isActive
}
